module.exports = __webpack_public_path__ + "img/gb32_2.prt.241bafe4.jpg";